import { render, staticRenderFns } from "./pdf.vue?vue&type=template&id=bcb502b8&"
import script from "./pdf.vue?vue&type=script&lang=js&"
export * from "./pdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports